// avstemming-payables-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avdp.assess.notAssessed': 'Not assessed',
  'avdp.assess.noAction': 'OK – no action',
  'avdp.assess.matchPayment': 'To be matched against payment',
  'avdp.assess.wrongPosting': 'Incorrect posting — to be corrected',
  'avdp.assess.missingPosting': 'Missing posting',
  'avdp.assess.duplicate': 'Duplicate',
  'avdp.assess.creditNote': 'To be settled against a credit note',
  'avdp.assess.awaitingDocs': 'Awaiting documentation',
  'avdp.assess.awaitingClient': 'Awaiting the client',
  'avdp.assess.nextPeriod': 'Follow up next period',
  'avdp.quick.needsAssessment': 'Needs assessment',
  'avdp.quick.allOpen': 'All open',
  'avdp.quick.overdue': 'Overdue',
  'avdp.quick.over90': 'Over 90 days',
  'avdp.quick.negative': 'Negative balances',
  'avdp.quick.duplicates': 'Possible duplicates',
  'avdp.quick.partlyPaid': 'Partly paid',
  'avdp.quick.foreign': 'Foreign-currency items',
  'avdp.quick.missingDoc': 'Missing voucher',
  'avdp.quick.paidAfter': 'Paid after period date',
  'avdp.quick.assessed': 'Fully assessed',
  'avdp.days.notRelevant': 'Not relevant',
  'avdp.days.notDue': 'Not due',
  'avdp.days.overdue': 'Overdue by {days} days',
  'avdp.flags.none': 'None',
  'avdp.flags.more': '+{count} more',
  'avdp.nav.overview': 'Overview',
  'avdp.nav.openItems': 'Open items',
  'avdp.nav.suppliers': 'Suppliers',
  'avdp.nav.controls': 'Controls',
  'avdp.nav.conclusion': 'Conclusion',
  'avdp.nav.blocked': 'Blocked',
  'avdp.nav.ready': 'Ready',
  'avdp.toast.noAccount': 'The area has no reconciliation account in this period.',
  'avdp.area.payables': 'Accounts payable',
  'avdp.ledger.title': 'Supplier ledger and open items',
  'avdp.filter.reset': 'Reset filters',
  'avdp.filter.supplier': 'Supplier: {name}',
  'avdp.filter.showAllSuppliers': 'Show all suppliers',
  'avdp.filter.controlAccount': 'Control account: {account}',
  'avdp.filter.showAllAccounts': 'Show all control accounts',
  'avdp.filter.ageGroup': 'Age group: {label}',
  'avdp.filter.showAllAges': 'Show all age groups',
  'avdp.col.supplier': 'Supplier',
  'avdp.col.docNo': 'Doc. no.',
  'avdp.col.type': 'Type',
  'avdp.col.invoiceDate': 'Invoice date',
  'avdp.col.due': 'Due',
  'avdp.col.original': 'Original',
  'avdp.col.openAmount': 'Open amount',
  'avdp.col.currency': 'Currency',
  'avdp.col.daysOverdue': 'Days overdue',
  'avdp.col.flag': 'Alert',
  'avdp.col.assessment': 'Assessment',
  'avdp.row.viewAssessment': 'View assessment',
  'avdp.row.assess': 'Assess',
  'avdp.ledger.noMatch': 'No supplier items match the filters.',
  'avdp.ledger.noOpen': 'No open supplier items in this period. If the client has no unpaid supplier invoices, there is no subledger to reconcile.',
  'avdp.header.controlAccount': 'Control account {accounts}',
  'avdp.header.responsible': 'Responsible: {name}',
  'avdp.header.title': '{area} – general ledger vs. subledger',
  'avdp.header.noControlAccount': 'No control account in the area',
  'avdp.header.matches': 'General ledger and subledger agree',
  'avdp.header.differs': 'General ledger and subledger differ',
  'avdp.header.noSubledger': 'No control account with a subledger',
  'avdp.header.needsAssessment': '{count} subledger items need assessment before the reconciliation can be sent for review.',
  'avdp.header.allAssessed': 'No subledger items remain to be assessed.',
  'avdp.balance.title': 'Automatic balance reconciliation',
  'avdp.balance.computedAt': 'The subledger is calculated as of {date}',
  'avdp.balance.booked': 'Booked balance, control account with subledger',
  'avdp.balance.ledgerAt': 'Supplier subledger as of {date}',
  'avdp.balance.difference': 'Difference',
  'avdp.balance.noSubledger': 'None of the area\'s accounts is the accounts payable account the app posts purchases to ({account}). There is then no subledger to compare the balance with, and the difference must be explained on the account itself.',
  'avdp.balance.mismatch': 'The control account does not agree with the subledger. The difference must be explained before the area can be reconciled — see the direct postings further down.',
  'avdp.balance.opening': 'Balance previous period',
  'avdp.balance.change': 'Change in the period',
  'avdp.balance.openInvoices': 'Open invoices',
  'avdp.balance.overdueAmount': 'Overdue amount',
  'avdp.balance.totalItems': 'Total items in the check',
  'avdp.balance.suppliersWithBalance': 'Suppliers with a balance',
  'avdp.accounts.title': 'Control accounts',
  'avdp.accounts.empty': 'No balance sheet accounts are linked to accounts payable in this period. Without a control account there is no booked balance to compare the subledger with.',
  'avdp.accounts.colAccount': 'Control account',
  'avdp.accounts.colBooked': 'Booked balance',
  'avdp.accounts.colSubledger': 'Subledger balance',
  'avdp.accounts.colDifference': 'Difference',
  'avdp.accounts.colStatus': 'Status',
  'avdp.accounts.noSubledger': 'No subledger',
  'avdp.accounts.deviation': 'Deviation',
  'avdp.accounts.matches': 'Agrees',
  'avdp.accounts.open': 'Open account',
  'avdp.card.ledgerVsSubledger': 'General ledger vs. subledger',
  'avdp.card.ledgerVsSubledgerHint': 'Booked balance compared with the sum of the open items at period end.',
  'avdp.card.old': 'Old items over 90 days',
  'avdp.card.oldHint': 'Open items overdue by more than 90 days.',
  'avdp.card.negative': 'Negative supplier balances',
  'avdp.card.negativeHint': 'Invoices that have been paid more than they were for. The supplier owes the company.',
  'avdp.card.duplicates': 'Possible duplicates',
  'avdp.card.affected': '{count} affected items',
  'avdp.card.duplicatesHint': 'Same supplier, same invoice date and same amount.',
  'avdp.card.paymentsNoInvoice': 'Payments without an invoice',
  'avdp.card.paymentsNoInvoiceHint': 'Debit lines on the control account with no supplier invoice behind them. See the direct postings further down.',
  'avdp.card.partlyPaid': 'Partly paid but still open',
  'avdp.card.partlyPaidHint': 'Items with a registered payment that are still open.',
  'avdp.card.missingDoc': 'Missing vouchers',
  'avdp.card.missingDocHint': 'Open items without a stored voucher.',
  'avdp.card.overdue30': 'Items overdue by more than 30 days',
  'avdp.card.overdue30Hint': 'Open items overdue by between 31 and 90 days.',
  'avdp.card.foreign': 'Foreign-currency items to review',
  'avdp.card.foreignHint': 'Open invoices in a currency other than NOK. The exchange rate on the balance sheet date must be checked.',
  'avdp.card.paidAfter': 'Paid after period date',
  'avdp.card.paidAfterHint': 'Items open at the period date that were paid afterwards — normally positive documentation.',
  'avdp.card.direct': 'Posted directly to the control account',
  'avdp.card.directHint': 'General ledger lines on the control accounts that do not come from a supplier invoice or a payment.',
  'avdp.card.title': 'Control card',
  'avdp.card.checksRun': 'Automatic checks run: {count} of {total}',
  'avdp.card.findings': 'Checks with findings: {count}',
  'avdp.card.manual': 'Items that need manual assessment: {count}',
  'avdp.card.hide': 'Hide',
  'avdp.card.showAll': 'Show all automatic checks',
  'avdp.card.activeFilter': 'Active filter: {label}',
  'avdp.card.itemsCount': '{count} items',
  'avdp.card.removeFilter': 'Remove filter',
  'avdp.aging.title': 'Age distribution (days overdue)',
  'avdp.aging.empty': 'No open supplier items at period end — nothing to distribute by age.',
  'avdp.aging.note': 'Calculated from the due date, not the invoice date.',
  'avdp.aging.colAge': 'Age',
  'avdp.aging.colCount': 'Number of items',
  'avdp.aging.colAmount': 'Open amount',
  'avdp.aging.colShare': 'Share',
  'avdp.aging.needsAssessment': 'Needs assessment',
  'avdp.aging.total': 'Total open items',
  'avdp.suppliers.emptyTitle': 'Suppliers with an open balance',
  'avdp.suppliers.empty': 'No suppliers have an open balance at period end. Concentration is measured by the open items, so without them there is no distribution to assess.',
  'avdp.suppliers.title': 'Suppliers with open items',
  'avdp.suppliers.topFive': 'The five largest make up {share} % of the balance',
  'avdp.suppliers.colSupplier': 'Supplier',
  'avdp.suppliers.colItems': 'Open items',
  'avdp.suppliers.colAmount': 'Open amount',
  'avdp.suppliers.colOverdue': 'Of which overdue',
  'avdp.suppliers.colOldest': 'Oldest item',
  'avdp.suppliers.colShare': 'Share',
  'avdp.suppliers.negative': 'Negative balance',
  'avdp.suppliers.days': '{days} days',
  'avdp.direct.title': 'Direct postings on the control account',
  'avdp.direct.empty': 'No general ledger lines on the control accounts come from anything other than an invoice or a payment. The check has run — it found nothing.',
  'avdp.direct.note': 'Postings in the period that do not come from a supplier invoice or a payment of one. A debit line with no invoice behind it is a payment that no invoice accounts for.',
  'avdp.direct.colDate': 'Date',
  'avdp.direct.colVoucher': 'Voucher',
  'avdp.direct.colText': 'Text',
  'avdp.direct.colAccount': 'Account',
  'avdp.direct.colType': 'Type',
  'avdp.direct.colAmount': 'Amount',
  'avdp.direct.paymentNoInvoice': 'Payment without an invoice',
  'avdp.direct.debtNoInvoice': 'Debt without an invoice',
  'avdp.checks.title': 'Automatic checks',
  'avdp.checks.note': 'The checks do not tick anything off in the professional checklist. They tell the person ticking off what they should have looked at.',
  'avdp.checks.colCheck': 'Check',
  'avdp.checks.colRun': 'Run',
  'avdp.checks.colResult': 'Result',
  'avdp.checks.run': 'Run',
  'avdp.checks.findingsCount': '{count} findings',
  'avdp.checks.none': 'No findings',
  'avdp.derived.old': 'All material old items have been assessed',
  'avdp.derived.negative': 'Negative supplier balances are explained',
  'avdp.derived.duplicate': 'Possible duplicates have been assessed',
  'avdp.derived.partlyPaid': 'Partly paid items have been investigated',
  'avdp.derived.foreign': 'Foreign-currency items have been checked',
  'avdp.derived.missingDoc': 'Items without a voucher have been handled',
  'avdp.blocker.one': '{count} subledger item needs assessment',
  'avdp.blocker.many': '{count} subledger items need assessment',
  'avdp.blocker.oneCritical': '{count} subledger item needs assessment, of which {critical} critical',
  'avdp.blocker.manyCritical': '{count} subledger items need assessment, of which {critical} critical',
  'avdp.blocker.diff': '{amount} of the difference against the subledger is unexplained',
  'avdp.blocker.pointOne': '{count} control point remains',
  'avdp.blocker.pointMany': '{count} control points remain',
  'avdp.check.title': 'Professional checklist',
  'avdp.check.titleReadOnly': 'Professional checklist (preparer\'s, read-only)',
  'avdp.check.noPoints': 'No control points are defined for accounts payable in this period.',
  'avdp.check.scope': 'The points apply to the whole area. A tick is saved on all the control accounts in the period.',
  'avdp.check.groupItems': 'Items that require handling',
  'avdp.check.groupAssessments': 'Overall professional assessments',
  'avdp.check.groupReady': 'Readiness',
  'avdp.check.count': '{done} of {total}',
  'avdp.check.processed': '{done} of {total} handled',
  'avdp.check.notApplicable': 'Not applicable this period',
  'avdp.check.followsAssessments': 'Follows from the assessments',
  'avdp.check.performedBy': 'Performed by {name}',
  'avdp.check.completed': '{done} of {total} control points completed',
  'avdp.concl.title': 'Conclusion and approval',
  'avdp.concl.placeholder': 'What does the review of accounts payable show for this period?',
  'avdp.concl.savedAs': 'Saved as the justification on the control point «{label}».',
  'avdp.concl.remainingRisk': 'Remaining risk',
  'avdp.concl.noRisk': 'Nothing remains that prevents the area from being sent for review.',
  'avdp.concl.followUp': 'Follow-up next period',
  'avdp.concl.noFollowUp': 'No assessments are marked for follow-up next period.',
  'avdp.concl.followed': 'Follow up',
  'avdp.concl.measure': 'Action: {text}',
  'avdp.concl.noMeasure': 'No action noted',
  'avdp.concl.deadline': 'Deadline {date}',
  'avdp.concl.openAssessment': 'Open assessment',
  'avdp.concl.send': 'Send the area for review',
  'avdp.concl.oneLeft': 'One thing remains before the area can be sent.',
  'avdp.concl.manyLeft': '{count} things remain before the area can be sent.',
  'avdp.drawer.reasonOverdue': 'The item is {days} days overdue',
  'avdp.drawer.reasonDuplicate': 'Possible duplicate of {ids}',
  'avdp.drawer.reasonOverpaid': 'Paid {paid} against a voucher of {gross}',
  'avdp.drawer.reasonPartlyPaid': 'Partly paid with {paid} in the period',
  'avdp.drawer.reasonPaidAfter': 'Paid {amount}, after the period date',
  'avdp.drawer.reasonPaidAfterOn': 'Paid {amount} on {date}, after the period date',
  'avdp.drawer.reasonCurrencyRate': 'Booked in {currency} at rate {rate}',
  'avdp.drawer.reasonCurrencyNoRate': 'Booked in {currency} with no stored rate',
  'avdp.drawer.reasonNoDoc': 'No voucher is stored on the purchase',
  'avdp.drawer.unknownOrgNo': 'Unknown org. no.',
  'avdp.drawer.close': 'Close',
  'avdp.drawer.invoiceDate': 'Invoice date',
  'avdp.drawer.dueDate': 'Due date',
  'avdp.drawer.daysOverdue': 'Days overdue',
  'avdp.drawer.originalAmount': 'Original amount',
  'avdp.drawer.openAtEnd': 'Open at period end',
  'avdp.drawer.paidInPeriod': 'Paid in the period',
  'avdp.drawer.paidAfterDate': 'Paid after period date',
  'avdp.drawer.currencyRate': 'Currency / rate',
  'avdp.drawer.currency': 'Currency',
  'avdp.drawer.controlAccount': 'Control account',
  'avdp.drawer.voucher': 'Voucher',
  'avdp.drawer.stored': 'Stored',
  'avdp.drawer.missing': 'Missing',
  'avdp.drawer.assessment': 'Assessment',
  'avdp.drawer.justification': 'Justification',
  'avdp.drawer.justificationRequired': 'Justification (required)',
  'avdp.drawer.justificationPlaceholder': 'What does the review of this item show?',
  'avdp.drawer.measure': 'Action',
  'avdp.drawer.measurePlaceholder': 'E.g. Ask the supplier to credit the duplicate',
  'avdp.drawer.followUpDeadline': 'Follow-up deadline',
  'avdp.drawer.markFollowUp': 'Mark for follow-up next period',
  'avdp.drawer.linkedDocOne': '{count} document is linked to the control account in this period.',
  'avdp.drawer.linkedDocMany': '{count} documents are linked to the control account in this period.',
  'avdp.drawer.needsJustification': 'This assessment requires a justification.',
  'avdp.drawer.save': 'Save assessment',
  'avdp.drawer.requestDocs': 'Ask the client for documentation',
});
